<template>
  <div>
    <h2>{{ $t("calendar.add_vehicle_to_order") }}</h2>
    <span class="title">{{ vehicle.make }} {{ vehicle.vehicle_model }} - {{ vehicle.license_plate }}</span>
    <div style="overflow: visible; min-height: 20em">
        <open-order-filter
          :from="from"
          @order-selected="setOrder"
        />
    </div>
    <div class="d-flex justify-content-end my-2">
      <button
        class="btn btn-secondary btn-sm me-2"
        @click.stop="$emit('cancel')"
      >
        {{ $t('common.cancel' ) }}
      </button>
      <button
        class="btn btn-success btn-sm"
        :disabled="!order || loading"
        @click.stop="submit"
      >
        {{ $t('common.add' ) }}
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>


<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import OpenOrderFilter from "@/components/order/OpenOrderFilter";
import {inject} from "vue";

export default {
    name: 'OrderVehicleAdder',
    components: {
        OpenOrderFilter,
    },
    mixins: [restApi],
    props: {
        from: {
            type: String,
            required: true
        },
        vehicle: {
            type: Object,
            default: null,
            required: true
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            order: null,
            loading: false,
        }
    },
    methods: {
        setOrder(order) {
            this.order = order
        },

        submit() {
            this.loading = true
            this.restUpdate(this.orderUrl + '/' + this.order.id + '/vehicle/' + this.vehicle.id , {}, this.success, this.fail)
        },

        success() {
          this.loading = false
          this.$emit('update', this.vehicle)
        },

        fail() {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        }

    }
}
</script>
